import { Segment, Fields, } from '../../model/index.js';
export class SegmentSequence {
    '1' = [
        Segment.CORE,
    ];
    '2' = [
        Segment.CORE,
    ];
    constructor(tcModel, options) {
        if (tcModel.version === 2) {
            if (tcModel.isServiceSpecific) {
                /**
 *
 *
 *
 *
 */
                this['2'].push(Segment.PUBLISHER_TC);
                this['2'].push(Segment.VENDORS_DISCLOSED);
            }
            else {
                const isForVendors = !!(options && options.isForVendors);
                /**
 *
 *
 *
 *
 */
                if (!isForVendors || tcModel[Fields.supportOOB] === true) {
                    this['2'].push(Segment.VENDORS_DISCLOSED);
                }
                if (isForVendors) {
                    /**
 *
 *
 *
 *
 *
 *
 */
                    if (tcModel[Fields.supportOOB] && tcModel[Fields.vendorsAllowed].size > 0) {
                        this['2'].push(Segment.VENDORS_ALLOWED);
                    }
                    /**
 *
 *
 */
                    this['2'].push(Segment.PUBLISHER_TC);
                }
            }
        }
    }
}
